import { Card } from "@material-ui/core";
import { FormikHelpers } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useNotify, useRefresh } from "react-admin";
import { getGeneral } from "../../../helpers/getGeneral";
import dataProvider from "../../../providers/dataProvider";
import { DescriptionForm } from "./DescriptionForm";
import "./style.css"
export interface StatisticState {
    totalWon: number,
    previousWinner: string,
    charity: number,
    charitableDonation: number,
    appDownload: number
}

export const DescriptionTab = () => {
    const [state, setState] = useState<StatisticState>()
    const docId = useRef<string | undefined>(undefined);
    const notify = useNotify();
    const refresh = useRefresh();
    useEffect(() => {
        const getStatistic = async () => {
            const general = await getGeneral()
            const statistic = general.statistic
            setState({
                totalWon: statistic.totalWon || 0,
                previousWinner: statistic.previousWinner || "",
                charity: statistic.charity || 0,
                charitableDonation: statistic.charitableDonation || 0,
                appDownload: statistic.appDownload || 0
            })
            docId.current = general._id;
        }
        getStatistic()
    }, [])

    const handleSubmitForm = async (
        values: StatisticState,
        actions: FormikHelpers<StatisticState>
    ) => {
        try {
            const result = await dataProvider.updateGeneral({
                id: docId.current,
                data: { statistic: values }
            });

            if (result.data) {
                notify(`Statistic successfully update`);
                refresh();
            }
        } catch (error) {
            notify("Sorry, something went wrong", "error");
        }
        actions.setSubmitting(false);
    }
    return (
        <Card component="div" className="tabCardWrapper creditsTabLayout">
            {state && <DescriptionForm state={state} handleSubmitForm={handleSubmitForm} />}
        </Card>
    )
}